// @ts-strict-ignore
/**
 * Created by claudenbach on 1/30/2017.
 */

import { LMFormatterService } from './lm-formatter.service';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';

export const lmButtonFormatter = (
  lmFormatterService: LMFormatterService,
  lmFormatUtilService: LMFormatUtilService,
  row: number,
  cell: number,
  value: any,
  columnDef: ListGridColumn,
  dataView: LMListDataView,
  dataGrid: SohoDataGridStatic
): string  => {

  columnDef.contentWidth = '100%';
  columnDef.cssClass = 'lm-button-formatter-container';

  if (dataView.isTreeMoreLink) {
    return lmFormatterService.getMoreLink(cell, dataView);
  }

  if (columnDef.displayField.visibility) {
    if (!lmFormatterService.isConditionValid(columnDef.displayField.visibility, dataView)) {
      return '';
    }
  }

  const displayValue = columnDef.displayField.title ? lmFormatUtilService.formatMessageRule(columnDef.displayField.title, dataView) : '';
  const formatButtonText = lmFormatterService.formatButtonText(row, cell, displayValue, columnDef, dataView, dataGrid);

  if (lmFormatterService.expandableRowCardView() && columnDef.columnNumber === 0) {
    return Soho.Formatters.Expander(row, cell, formatButtonText, columnDef, dataView, dataGrid);
  }

  return formatButtonText;
};
